import SarafiComponent from "components/sarafiComponents/SarafiComponent";
import React, { useState, useContext, useEffect } from "react";
import user from "assets/images/Icon awesome-user-alt.png";
import twitteContext from "context/twitteContext";
import CryptoPrices from "components/homeComponent/CryptoPrices";
import { useParams } from "react-router-dom";

function SarafiPage({ USDTPrice, priceList }) {
  const { exchangeName } = useParams();
  const allTwittes = [
    {
      isComment: false,
      key: 1,
      parentKey: 1,
      type: 1,
      name: "mani",
      id: 636,
      image: "",
      time: "later",
      hashtag: [],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
          خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
          مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
      comments: [],
    },
    {
      isComment: false,
      key: 2,
      parentKey: 3,
      type: 1,
      name: "ahmad",
      id: 8989,
      image: "",
      time: "later",
      hashtag: [{ value: "پالایش" }],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
            خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
            مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
      comments: [],
    },
    {
      isComment: false,
      key: 3,
      parentKey: 3,
      type: 2,
      name: "علی",
      id: "ali8554",
      image: user,
      time: "later",
      hashtag: [{ value: "خکاوه" }],
      content: {
        type: 1,
        value: {
          text: `فعلا به تکنیکال خوب جواب میده دیروز رفت برای
                استراحت من از صف خرید خارج شدم`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
      comments: [],
    },
    {
      isComment: false,
      key: 4,
      parentKey: 4,
      type: 1,
      name: "sami",
      id: 969,
      image: "",
      time: "later",
      hashtag: [],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
          خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
          مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
      comments: [],
    },
    {
      isComment: false,
      key: 5,
      parentKey: 5,
      type: 1,
      name: "samin",
      id: 852,
      image: "",
      time: "later",
      hashtag: [],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
          خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
          مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
      comments: [],
    },
  ];
  const firstTwittes = [
    {
      isComment: false,
      key: 1,
      parentKey: 1,
      type: 1,
      name: "saeede",
      id: 858,
      image: "",
      time: "later",
      hashtag: [],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
          خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
          مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
      comments: [],
    },
    {
      isComment: false,
      key: 2,
      parentKey: 3,
      type: 1,
      name: "sara",
      id: 969,
      image: "",
      time: "later",
      hashtag: [{ value: "پالایش" }],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
            خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
            مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
      comments: [],
    },
    {
      isComment: false,
      key: 3,
      parentKey: 3,
      type: 2,
      name: "علی",
      id: "ali8554",
      image: user,
      time: "later",
      hashtag: [{ value: "خکاوه" }],
      content: {
        type: 1,
        value: {
          text: `فعلا به تکنیکال خوب جواب میده دیروز رفت برای
                استراحت من از صف خرید خارج شدم`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
      comments: [],
    },
  ];
  const { setTwittes } = useContext(twitteContext);
  useEffect(() => {
    setTwittes(firstTwittes);
  }, []);
  return (
    <div>
      {/* <SarafiComponent allTwittes={allTwittes} firstTwittes={firstTwittes} /> */}
      <CryptoPrices
        information={priceList[exchangeName]}
        USDTPrice={USDTPrice}
      />
    </div>
  );
}

export default SarafiPage;
